// extracted by mini-css-extract-plugin
module.exports = {"container":"terms-module--container--2nNsR","body":"terms-module--body--K6kiV","sectionHeader":"terms-module--sectionHeader--RafUi"};